// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"a7046007","196":"74832414","466":"4593edd1","485":"5056fe7d","580":"f735ce68","955":"74832414"}[chunkId] + ".chunk.css";
};